import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import moment from 'moment';
import {
    MontageListItem,
    MONTAGE_LIST_TABLE_COLUMNS,
    filterMontageLists,
} from '@/modules/Logistics/composables/LogisticsTableHelper';
import { downloadTableAsExcel } from '@/helpers/PrintHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'MontageTable',
  props: {
    dataSource: null,
    searchQuery: null,
    loading: { type: Boolean }
  },
  emits: ["updateSearch", "row-click", "delete"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'updateSearch', value: string): void;
    (e: 'row-click', record: MontageListItem): void;
    (e: 'delete', ids: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    dataSource: MontageListItem[];
    searchQuery: string;
    loading: boolean;
};





const selectedRowKeys = ref<number[]>([]);

const columns = MONTAGE_LIST_TABLE_COLUMNS;

const filteredData = computed(() => {
    return filterMontageLists(props.dataSource, props.searchQuery);
});

const rowSelection = computed(() => ({
    selectedRowKeys: selectedRowKeys.value,
    onChange: (keys: number[]) => {
        selectedRowKeys.value = keys;
    },
}));

function handleSearchChange(e: any) {
    emit('updateSearch', e.target.value);
}

function customRow(record: MontageListItem) {
    return {
        on: {
            click: () => emit('row-click', record),
        },
        style: {
            cursor: 'pointer',
        },
    };
}

function handleDeleteSelected() {
    emit('delete', selectedRowKeys.value);
    selectedRowKeys.value = [];
}

function handleDownloadExcel() {
    downloadTableAsExcel(columns, filteredData.value, 'montage-lists');
}

function rowClassName(record: MontageListItem) {
    const today = moment().format('DD.MM.YYYY');
    return record.date === today ? 'today-row' : '';
}

return { __sfc: true,props, emit, selectedRowKeys, columns, filteredData, rowSelection, handleSearchChange, customRow, handleDeleteSelected, handleDownloadExcel, rowClassName }
}

})